import { getInstance } from "../../app";
import "./style.css";
import { wpDesktop } from "../../app/breakpoints";

export default class Technologies {
  static selector = ".technologies";

  constructor(block) {
    this.block = block;

    this.openWheelButton = this.block.querySelector(
      ".technologies__open-wheel"
    );
    this.wheelControls = this.block.querySelector(".mind-map-controls");
    this.closeWheelButton = this.block.querySelector(
      ".mind-map-controls__close-wheel"
    );
    this.titleBar = this.block.querySelector(".technologies__title-bar");

    this.closePanelButton = this.block.querySelector(
      ".technologies__close-button"
    );
    this.wheel = this.block.querySelector(".mind-map");
    this.svgElement = this.wheel.querySelector("svg");
    this.svgContainer = this.wheel.querySelector(".mind-map__wheel-container");

    this.closedMapClass = "map-closed";
    this.enteredMapClass = "map-entered";
  }

  isTouchMode = () =>
    window.innerWidth < wpDesktop ||
    "ontouchstart" in window ||
    ( window.innerWidth < wpDesktop && navigator.maxTouchPoints > 0 ) ||
    ( window.innerWidth < wpDesktop && navigator.msMaxTouchPoints > 0 ) ;

  showWheelControls = () => {
    this.openWheelButton.classList.add("hidden");
    this.wheelControls.classList.add("mind-map-controls--visible");
  };

  hideWheelControls = () => {
    this.wheelControls.classList.remove("mind-map-controls--visible");
  };

  handleOpenWheel = () => {
    if (this.isTouchMode()) {
      // is mobile
      window.App.navigateTo("/technologies?technology_first_level=none");
    } else {
      // hide title bar
      this.titleBar.classList.add("technologies__title-bar--hidden");
    }
  };

  handleCloseWheel = () => {
    this.hideWheelControls();
  };

  onTitleBarHidden = (e) => {
    if (
      e.propertyName === "transform" &&
      !this.wheelControls.classList.contains("mind-map-controls--visible") &&
      this.titleBar.classList.contains("technologies__title-bar--hidden")
    ) {
      //  title panel was closed
      this.wheelInstance.enterWheel();
    } else if (
      e.propertyName === "transform" &&
      !this.wheelControls.classList.contains("mind-map-controls--visible") &&
      !this.titleBar.classList.contains("technologies__title-bar--hidden")
    ) {
      // title panel was opened
      this.openWheelButton.classList.remove("hidden");
    }
  };

  onWheelControlsHidden = (e) => {
    if (
      e.propertyName === "opacity" &&
      this.titleBar.classList.contains("technologies__title-bar--hidden") &&
      !this.wheelControls.classList.contains("mind-map-controls--visible")
    ) {
      // show title bar
      this.wheelInstance.closeWheel();
    }
  };

  onWheelTransitionEnd = (e) => {
    if (
      e.propertyName === "transform" &&
      this.svgContainer.classList.contains(this.enteredMapClass)
    ) {
      this.showWheelControls();
      this.svgContainer.classList.remove(this.closedMapClass);
    }
  };

  onReady() {
    if (this.openWheelButton) {
      this.openWheelButton.addEventListener("click", this.handleOpenWheel);
    }

    if (this.closeWheelButton) {
      this.closeWheelButton.addEventListener("click", this.handleCloseWheel);
    }

    this.titleBar.addEventListener("transitionend", this.onTitleBarHidden);

    this.wheelControls.addEventListener(
      "transitionend",
      this.onWheelControlsHidden
    );

    this.svgContainer.addEventListener(
      "transitionend",
      this.onWheelTransitionEnd
    );

    setTimeout(() => {
      this.wheelInstance = getInstance(document.querySelector(".mind-map"));
    }, 200);
  }

  onResize() {
    if (
      !this.isSwitchingToMobile &&
      this.titleBar.classList.contains("technologies__title-bar--hidden") &&
      this.isTouchMode()
    ) {
      // is mobile and title bar is hidden
      this.isSwitchingToMobile = true;
      window.location.href = "/technologies?technology_first_level=none";
    }
  }

  onDestroy() {
    if (this.openWheelButton) {
      this.openWheelButton.removeEventListener("click", this.handleOpenWheel);
    }

    if (this.closeWheelButton) {
      this.closeWheelButton.removeEventListener(
        "click",
        this.handleCloseWheelClick
      );
    }

    this.titleBar.removeEventListener("transitionend", this.onTitleBarHidden);

    this.closeWheelButton.removeEventListener(
      "transitionend",
      this.onWheelControlsHidden
    );
  }
}
